import Header from "../blocks/header";
import Dashboard from "../blocks/dashboard";
import Toolbar from "@mui/material/Toolbar";
import * as React from "react";
import Copyright from "../blocks/copyright";
import Box from "@mui/material/Box";
import {useNavigate, useParams} from "react-router-dom";
import {useTranslation} from "react-i18next";
import TextField from "@mui/material/TextField";
import {useEffect, useState} from "react";
import {connect} from "react-redux";
import {getAllVerifyResponse} from "../store/logIn";
import Button from "@mui/material/Button";
import {toast} from "react-toastify";
import axios from "axios";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ReplyIcon from "@mui/icons-material/Reply";
import {editSaveProblem, getProblem, messageReset} from "../store/problems";
import {TextareaAutosize, Dialog, DialogTitle, DialogContent, DialogActions, IconButton} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const BASE_URL = process.env.REACT_APP_API_URL || 'https://ishlabchiqarish.uzkoj.uz/api/'

function ViewProblem(props) {
    const navigate = useNavigate()
    const params = useParams()
    const {t} = useTranslation()

    const is_main    = JSON.parse(localStorage.getItem('is_main') || 'false')
    const my_user_id = JSON.parse(localStorage.getItem('user_id') || '0')

    const problem = props.problem_single || {}

    // Viloyat faqat TASHKILOT muammosiga javob beradi (o'zigaga emas)
    const problem_owner_id = problem.user?.id
    
    const can_answer = is_main

    const [answerText, setAnswerText]   = useState('')
    const [submitting, setSubmitting]   = useState(false)
    const [answerModal, setAnswerModal] = useState(false)

    useEffect(() => {
        props.getProblem(params.id)
    }, [params.id])

    function submitAnswer() {
        if (!answerText.trim()) return
        setSubmitting(true)
        const token = JSON.parse(localStorage.getItem('token'))
        axios.post(
            `${BASE_URL}problems/${params.id}/answer/`,
            {answer: answerText},
            {headers: {Authorization: `Bearer ${token}`}}
        ).then(() => {
            toast.success(t('save_success'), {theme: 'colored'})
            setAnswerText('')
            setAnswerModal(false)
            props.getProblem(params.id)
        }).catch(() => {
            toast.error(t('save_error'), {theme: 'colored'})
        }).finally(() => setSubmitting(false))
    }

    function formatDate(val) {
        if (!val) return '-'
        const d = new Date(val)
        const pad = n => String(n).padStart(2, '0')
        return `${pad(d.getDate())}.${pad(d.getMonth()+1)}.${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
    }

    return (
        <div>
            <div className={'page'}>
                <Header/>
                <Dashboard/>
                <Box component="main" sx={{flexGrow:1, height:'100vh', overflow:'auto'}}>
                    <Toolbar/>
                    <div className={'main'} style={{maxWidth: '860px'}}>

                        {/* Sarlavha + Javob yozish tugmasi */}
                        <div style={{display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:'24px', flexWrap:'wrap', gap:'12px'}}>
                            <Button variant="outlined" startIcon={<ChevronLeftIcon/>} onClick={() => navigate(-1)}>
                                {t('back')}
                            </Button>
                            {can_answer && (
                                <Button
                                    variant="contained"
                                    color={problem.is_answered ? 'warning' : 'primary'}
                                    startIcon={<ReplyIcon/>}
                                    onClick={() => {
                                        setAnswerText(problem.answer || '')
                                        setAnswerModal(true)
                                    }}
                                    sx={{borderRadius:'8px', textTransform:'none', fontWeight:600, px:3}}
                                >
                                    {problem.is_answered ? t('edit_answer') : t('write_answer')}
                                </Button>
                            )}
                        </div>

                        {/* Muammo ma'lumotlari */}
                        <div style={{
                            background:'#fff', border:'1px solid #e5e7eb',
                            borderRadius:'12px', padding:'28px',
                            boxShadow:'0 2px 8px rgba(0,0,0,0.05)', marginBottom:'24px'
                        }}>
                            <div style={{marginBottom:'20px'}}>
                                <div style={{fontSize:'12px', color:'#6b7280', marginBottom:'4px', fontWeight:500}}>
                                    {t('problem_title')}
                                </div>
                                <div style={{fontSize:'16px', fontWeight:600, color:'#111827'}}>
                                    {problem.title || '-'}
                                </div>
                            </div>

                            <div style={{marginBottom:'20px'}}>
                                <div style={{fontSize:'12px', color:'#6b7280', marginBottom:'6px', fontWeight:500}}>
                                    {t('problem_text')}
                                </div>
                                <div style={{
                                    background:'#f9fafb', border:'1px solid #e5e7eb',
                                    borderRadius:'8px', padding:'14px 16px',
                                    fontSize:'14px', color:'#1f2937',
                                    whiteSpace:'pre-wrap', lineHeight:'1.7', minHeight:'80px'
                                }}>
                                    {problem.text || '-'}
                                </div>
                            </div>

                            <div style={{display:'flex', gap:'32px', flexWrap:'wrap'}}>
                                {problem.user?.user_name && (
                                    <div>
                                        <div style={{fontSize:'12px', color:'#6b7280', fontWeight:500}}>{t('title_company')}</div>
                                        <div style={{fontSize:'14px', color:'#111827', marginTop:'2px'}}>{problem.user.user_name}</div>
                                    </div>
                                )}
                                <div>
                                    <div style={{fontSize:'12px', color:'#6b7280', fontWeight:500}}>{t('problem_date')}</div>
                                    <div style={{fontSize:'14px', color:'#111827', marginTop:'2px'}}>{formatDate(problem.modified)}</div>
                                </div>
                                <div>
                                    <span style={{
                                        padding:'3px 12px', borderRadius:'12px', fontSize:'12px', fontWeight:600,
                                        background: problem.is_answered ? '#dcfce7' : '#fef9c3',
                                        color: problem.is_answered ? '#15803d' : '#92400e',
                                    }}>
                                        {problem.is_answered ? t('answered') : t('not_answered')}
                                    </span>
                                </div>
                            </div>
                        </div>

                        {/* Mavjud javob */}
                        {problem.is_answered && (
                            <div style={{
                                background:'linear-gradient(135deg, #f0fdf4, #dcfce7)',
                                border:'1px solid #86efac',
                                borderLeft:'4px solid #16a34a',
                                borderRadius:'12px',
                                padding:'20px 24px',
                                boxShadow:'0 2px 8px rgba(22,163,74,0.08)'
                            }}>
                                <div style={{display:'flex', alignItems:'center', gap:'8px', marginBottom:'12px'}}>
                                    <span style={{fontWeight:600, color:'#15803d', fontSize:'15px'}}>
                                        {t('answer')}
                                    </span>
                                    <span style={{
                                        marginLeft:'auto', fontSize:'12px', color:'#6b7280',
                                        background:'#fff', padding:'3px 12px', borderRadius:'20px',
                                        border:'1px solid #d1fae5'
                                    }}>
                                        {problem.answered_by_name} &nbsp;·&nbsp;
                                        {formatDate(problem.answered_at)}
                                    </span>
                                </div>
                                <p style={{margin:0, whiteSpace:'pre-wrap', color:'#1f2937', fontSize:'14px', lineHeight:'1.7'}}>
                                    {problem.answer}
                                </p>
                            </div>
                        )}
                    </div>

                    {/* Javob yozish modali */}
                    <Dialog
                        open={answerModal}
                        onClose={() => setAnswerModal(false)}
                        fullWidth maxWidth="sm"
                        PaperProps={{sx:{borderRadius:'16px', p:1}}}
                    >
                        <DialogTitle sx={{display:'flex', alignItems:'center', justifyContent:'space-between', pb:1, fontWeight:700, fontSize:'18px'}}>
                            <span>
                                <ReplyIcon sx={{mr:1, verticalAlign:'middle', color:'#2563eb'}}/>
                                {problem.is_answered ? t('edit_answer') : t('write_answer')}
                            </span>
                            <IconButton onClick={() => setAnswerModal(false)} size="small">
                                <CloseIcon fontSize="small"/>
                            </IconButton>
                        </DialogTitle>
                        <DialogContent sx={{pt:2}}>
                            <TextField
                                fullWidth multiline rows={6} variant="outlined"
                                placeholder={t('write_answer') + '...'}
                                value={answerText}
                                onChange={e => setAnswerText(e.target.value)}
                                sx={{'& .MuiOutlinedInput-root':{borderRadius:'10px', fontSize:'14px'}}}
                            />
                        </DialogContent>
                        <DialogActions sx={{px:3, pb:3, gap:1}}>
                            <Button onClick={() => setAnswerModal(false)} variant="outlined"
                                    sx={{borderRadius:'8px', textTransform:'none', px:3}}>
                                {t('cancel')}
                            </Button>
                            <Button onClick={submitAnswer} variant="contained" color="success"
                                    disabled={submitting || !answerText.trim()}
                                    sx={{borderRadius:'8px', textTransform:'none', fontWeight:600, px:4}}>
                                {submitting ? t('saving') : t('send_answer')}
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Copyright/>
                </Box>
            </div>
        </div>
    )
}

export default connect(props => props.problems, {
    getProblem, editSaveProblem, getAllVerifyResponse, messageReset
})(ViewProblem)